import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Eye, EyeOff, KeyRound, Lock, LockKeyhole, LucideAngularModule, User } from "lucide-angular";
import { CommonTranslateModule } from "../../utils/common-translate.module";
import { OrganizationSwitcherModule } from "../organization-switcher/organization-switcher.module";
import { UiBackButtonModule } from "../ui-back-button/ui-back-button.module";
import { UserProfileComponent } from "./user-profile.component";

@NgModule({
  declarations: [UserProfileComponent],
  imports: [
    CommonModule,
    CommonTranslateModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    UiBackButtonModule,
    OrganizationSwitcherModule,
    LucideAngularModule.pick({ User, KeyRound, Lock, LockKeyhole, Eye, EyeOff }),
  ],
  exports: [UserProfileComponent],
})
export class UserProfileModule {}
